<template>
  <!-- Create / Edit -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
          <!-- ========================================= -->
          <!--             Registration form             -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("registrationForm") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('nameCollector')"
              v-model="form.name"
              :rules="nameRules"
              required
              clearable
              outlined
              dense
              autofocus
            ></v-text-field>
          </div>
          <!-- ========================================= -->
          <!--                Regionals                  -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("linkRegional") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-autocomplete
              v-model="form.regionals.select"
              :items="form.regionals.items"
              :rules="selectRules"
              @change="requestRoutes(form.regionals.select)"
              item-text="name_regional"
              item-value="id"
              :label="$t('selectRegional')"
              outlined
              :disabled="edit"
            ></v-autocomplete>
          </div>
          <!-- ========================================= -->
          <!--                Rotas                      -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("linkRoute") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-select
              v-model="form.routes.select"
              :items="form.routes.items"
              :rules="selectRules"
              item-text="nome"
              item-value="id"
              :label="$t('selectRoutes')"
              outlined
              multiple
              chips
              :disabled="form.regionals.select == ''"
            ></v-select>
          </div>

          <!-- ========================================= -->
          <!--                Credentials                -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4"
            >{{ $t("credentials") }}
          </v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('login')"
              v-model="form.login"
              :rules="usernameRules"
              required
              clearable
              outlined
              dense
              autocapitalize="off"
            ></v-text-field>

            <template v-if="edit">
              <v-btn @click="editPassword = !editPassword" class="mb-3">
                {{ $t("changePassword") }}
              </v-btn>
            </template>
            <template v-if="editPassword || !edit">
              <v-text-field
                :class="[
                  !form.password || show ? 'show-password' : 'hide-password',
                ]"
                :label="$t('password')"
                v-model="form.password"
                :rules="passwordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
              <v-text-field
                :class="[
                  !form.confirmPassword || show1
                    ? 'show-password'
                    : 'hide-password',
                ]"
                :label="$t('confirmPassword')"
                v-model="form.confirmPassword"
                :rules="passMatch"
                required
                clearable
                outlined
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
            </template>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-alert
        class="ma-4"
        type="warning"
        v-for="item in handleError.items"
        :key="item"
        close-icon
      >
        {{ item }}
      </v-alert>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          v-on:click.prevent="updateCollectors"
          type="submit"
          :disabled="!valid"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "administrator-collector-update",
  data: () => ({
    // Utils
    valid: false,
    show: false,
    show1: false,
    loading: false,
    editPassword: false,
    // Form data:
    form: {
      name: "",
      regionals: {
        select: "",
        items: [],
      },
      routes: {
        select: [],
        items: [],
      },

      // Credencials
      login: "",
      password: "",
      confirmPassword: "",
    },
    // Transforma type password em type text
    fieldTypes: {
      password: "text",
    },
    // Validate Forms:
    nameRules: [validate.required, validate.max],
    requiredRules: [validate.required],
    selectRules: [validate.selectRequired],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.usernameAz09,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    required: validate.required,
    // Handle Error:
    handleError: {
      items: [],
    },
    // Edit
    edit: false,
    id_user: "",
  }),
  async mounted() {
    // =================================================== //
    // SET - Select Regionals
    // =================================================== //
    let requestUsersRegionals = this.$request.post(
      "/administrator/regionals/list",
      { status: 1 }
    );

    const usersRegionals = await requestUsersRegionals;
    this.form.regionals.items = usersRegionals.dados;

    // =================================================== //
    // IF - Edit
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    this.edit = true;

    this.id_user = this.$route.params.id;
    let routeData = await this.$request.post(
      "/administrator/collectors/getCollector",
      {
        id_user: this.id_user,
      }
    );

    // [ Edit ] - Set inputs form
    const { routesCollectors } = routeData;
    const { nome, id_regional, login } = routeData.dados;

    this.form.name = nome;
    this.form.regionals.select = id_regional;
    this.form.routes.select = routesCollectors;
    this.form.login = login;
    await this.requestRoutes(id_regional);
    routesCollectors.forEach((element) => {
      this.form.routes.items.unshift(element);
    });
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    // // Repet password
    passMatch() {
      const rules = [];
      let required = this.$t("requiredInput");
      let repeatPassWord = this.$t("repeatThePassword");
      // Required
      if (this.form.confirmPassword) {
        const rule = (v) => !!v || required;
        rules.push(rule);
      }

      // Confirm Password
      if (this.form.password) {
        const rule = (v) => (!!v && v) === this.form.password || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async requestRoutes(id_regional) {
      // Reset fileds route
      this.form.routes.items = [];
      this.edit ? null : (this.form.routes.select = []);

      // =================================================== //
      // SET - Select Route
      // =================================================== //
      let routesAvailable = this.$request.post(
        "/administrator/collectors/routesAvailable",
        { id_regional }
      );

      // Reset fields

      // Request's Simultaneously
      let routes = await routesAvailable;
      if (routes.dados != undefined) {
        routes.dados.forEach((element) => {
          this.form.routes.items.push(element);
        });
      }
    },
    //
    // updateCollectors: Create or Edit Agent.
    async updateCollectors() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Form
      const formUpdateCollectors = {
        nome: this.form.name,
        login: this.form.login,
        password: this.form.password,
        id_regional: this.form.regionals.select,
      };

      // Handler routes to formUpdateCollectors
      const selected = this.form.routes.select;
      const routes = {};
      for (let i = 0; i < selected.length; i++) {
        routes[`routes[${i}]`] =
          selected[i].id == undefined ? selected[i] : selected[i].id;
      }

      Object.assign(formUpdateCollectors, routes);

      try {
        if (this.edit) {
          Object.assign(formUpdateCollectors, { id_collector: this.id_user });
        }

        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "administrator/collectors/editCollector"
          : "administrator/collectors/addCollector";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateCollectors
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    // Tratando password
    // handleType() {
    //   this.fieldTypes.password = "password";
    // },
  },
};
</script>
